import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class filterQuery {
    containsAllQueryCondition(query, filterOption) {
        query.containsAll(filterOption.field, filterOption.value);
    }
    startsWithQueryCondition(query, filterOption) {
        query.startsWith(filterOption.field, filterOption.value);
    }
    fullTextQueryCondition(query, filterOption) {
        query.fullText(filterOption.field, filterOption.value);
    }
}